import { render, staticRenderFns } from "./IconDragLeftRight.vue?vue&type=template&id=593d2c59&"
import script from "./IconDragLeftRight.vue?vue&type=script&lang=js&"
export * from "./IconDragLeftRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports